<template>
  <a-modal
    title="多号互通设置"
    :width="600"
    :visible="visible"
    :confirmLoading="confirmLoading"
    @cancel="handleCancel"
    :maskClosable="false"
  >
    <a-spin :spinning="confirmLoading || pullLoading">
      <a-form :form="form">
        <a-form-item label="目标数据库子账号" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input :value="SubAccountInput" read-only placeholder="请选择" />
          <a class="select-btn" @click="$refs.selectRobotModal.show()">选择目标数据库子账号</a>
        </a-form-item>
        <a-form-item label="淘宝联盟" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input :value="TaobaoUnionInput" read-only placeholder="请选择" />
          <a class="select-btn" @click="$refs.selectTaobaoModal.show()">选择淘宝联盟</a>
        </a-form-item>
        <a-form-item label="淘宝副联盟" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input :value="SubTaobaoUnionInput" read-only placeholder="请选择" />
          <a class="select-btn" @click="$refs.selectSubTaobaoModal.show()">选择淘宝副联盟</a>
        </a-form-item>
        <a-form-item label="京东联盟" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input :value="JingdongUnionInput" read-only placeholder="请选择" />
          <a class="select-btn" @click="$refs.selectJingdongModal.show()">选择京东联盟</a>
        </a-form-item>
        <a-form-item label="多多进宝" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input :value="JinbaoUnionInput" read-only placeholder="请选择" />
          <a class="select-btn" @click="$refs.selectJinbaoModal.show()">选择多多进宝</a>
        </a-form-item>
        <a-form-item label="淘宝推广位ID" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-model="taobao_union_pid" placeholder="请填写" />
        </a-form-item>
        <a-form-item label="淘宝副联盟推广位ID" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-model="sub_taobao_union_pid" placeholder="请填写" />
        </a-form-item>
        <a-form-item label="京东推广位ID" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-model="jingdong_union_pid" placeholder="请填写" />
        </a-form-item>
        <a-form-item label="多多进宝推广位ID" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-model="jinbao_union_pid" placeholder="请填写" />
        </a-form-item>
      </a-form>
    </a-spin>
    <template slot="footer">
      <a-button @click="handleCancel">取消</a-button>
      <a-button :loading="confirmLoading" type="primary" @click="handleSubmit">确定</a-button>
    </template>
    <select-robot-modal ref="selectRobotModal" @change="handleChangeSubAccount"></select-robot-modal>
    <select-taobao-modal ref="selectTaobaoModal" @change="handleChangeTaobao"></select-taobao-modal>
    <select-taobao-modal ref="selectSubTaobaoModal" @change="handleChangeSubTaobao"></select-taobao-modal>
    <select-jingdong-modal ref="selectJingdongModal" @change="handleChangeJingdong"></select-jingdong-modal>
    <select-jinbao-modal ref="selectJinbaoModal" @change="handleChangeJinbao"></select-jinbao-modal>
  </a-modal>
</template>

<script>
import DeviceApi from '@/api/device'
import SelectRobotModal from '@/views/components/SelectRobotModal'
import SelectTaobaoModal from '@/views/components/SelectTaobaoModal'
import SelectJingdongModal from '@/views/components/SelectJingdongModal'
import SelectJinbaoModal from '@/views/components/SelectJinbaoModal'
export default {
  components: {
    SelectRobotModal,
    SelectTaobaoModal,
    SelectJingdongModal,
    SelectJinbaoModal
  },
  data() {
    return {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 7 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 13 }
      },
      mdl: {},
      currentRobotId: '',
      visible: false,
      confirmLoading: false,
      pullLoading: false,
      form: this.$form.createForm(this),
      sub_account: { id: '' },
      taobao_union: {},
      sub_taobao_union: {},
      jingdong_union: {},
      jinbao_union: {},
      taobao_union_pid: '',
      sub_taobao_union_pid: '',
      jingdong_union_pid: '',
      jinbao_union_pid: ''
    }
  },
  computed: {
    SubAccountInput() {
      const obj = this.sub_account
      if (obj.id) {
        return `${obj.id}`
      } else {
        return
      }
    },
    TaobaoUnionInput() {
      const obj = this.taobao_union
      if (obj.id) {
        return `${obj.taobao_user_id}（${obj.taobao_user_nick}）`
      } else {
        return
      }
    },
    JingdongUnionInput() {
      const obj = this.jingdong_union
      if (obj.id) {
        return `${obj.union_id}`
      } else {
        return
      }
    },
    JinbaoUnionInput() {
      const obj = this.jinbao_union
      if (obj.owner_id) {
        return `${obj.owner_id}（${obj.owner_name}）`
      } else {
        return
      }
    },
    SubTaobaoUnionInput() {
      const obj = this.sub_taobao_union
      if (obj.id) {
        return `${obj.taobao_user_id}（${obj.taobao_user_nick}）`
      } else {
        return
      }
    }
  },
  methods: {
    show(currentRobotId) {
      this.currentRobotId = currentRobotId
      this.visible = true
      this.getData()
    },
    handleCancel() {
      this.visible = false
      this.initData()
    },
    getData() {
      this.pullLoading = true
      DeviceApi.getWarrantInfo({ sub_id: this.currentRobotId })
        .then(res => {
          if (res.code === 1) {
            const setting_value = res.data.setting_value
            const obj = JSON.parse(setting_value)
            this.sub_account = { id: res.data.dest_sub_id }
            this.taobao_union = obj.taobao_auth.main_taobao_auth_info
            this.sub_taobao_union = obj.taobao_auth.sub_taobao_auth_info
            this.jingdong_union = obj.jingdong_auth
            this.jinbao_union = obj.pinduoduo_auth
            this.taobao_union_pid = obj.taobao_auth.main_taobao_auth_info['main_pid']
            this.sub_taobao_union_pid = obj.taobao_auth.sub_taobao_auth_info['sub_pid']
            this.jingdong_union_pid = obj.jingdong_auth['pid']
            this.jinbao_union_pid = obj.pinduoduo_auth['pid']
          } else {
            // this.$message.error('请配置多号互通信息')
          }
        })
        .finally(() => {
          this.pullLoading = false
        })
    },
    handleSubmit(e) {
      e.preventDefault()
      const sub_account = this.sub_account
      const taobao_union = this.taobao_union
      const sub_taobao_union = this.sub_taobao_union
      const jingdong_union = this.jingdong_union
      const jinbao_union = this.jinbao_union
      const taobao_union_pid = this.taobao_union_pid
      const sub_taobao_union_pid = this.sub_taobao_union_pid
      const jingdong_union_pid = this.jingdong_union_pid
      const jinbao_union_pid = this.jinbao_union_pid
      let taobao_param = {
        main_taobao_auth_info: taobao_union,
        sub_taobao_auth_info: sub_taobao_union
      }
      let jingdong_param = jingdong_union
      let jinbao_param = jinbao_union
      taobao_param['main_taobao_auth_info']['main_pid'] = taobao_union_pid
      taobao_param['sub_taobao_auth_info']['sub_pid'] = sub_taobao_union_pid
      jingdong_param['pid'] = jingdong_union_pid
      jinbao_param['pid'] = jinbao_union_pid
      this.confirmLoading = true
      DeviceApi.setWarrantInfo({
        origin_sub_id: this.currentRobotId,
        sub_id: sub_account.id + '',
        taobao_auth_info: JSON.stringify(taobao_param),
        pinduoduo_auth_info: JSON.stringify(jinbao_param),
        jingdong_auth_info: JSON.stringify(jingdong_param)
      })
        .then(res => {
          if (res.code === 1) {
            this.form.resetFields()
            this.$message.success('操作成功')
            this.visible = false
            this.$emit('ok')
            this.initData()
          } else {
            this.$message.error(res.msg)
          }
        })
        .finally(() => {
          this.confirmLoading = false
        })
    },
    initData() {
      this.sub_account = { id: '' }
      this.taobao_union = {}
      this.sub_taobao_union = {}
      this.jingdong_union = {}
      this.jinbao_union = {}
      this.taobao_union_pid = ''
      this.sub_taobao_union_pid = ''
      this.jingdong_union_pid = ''
      this.jinbao_union_pid = ''
    },
    handleChangeSubAccount(data) {
      this.sub_account = data
      this.$refs.selectRobotModal.handleCancel()
    },
    handleChangeTaobao(data) {
      this.taobao_union = data
      this.$refs.selectTaobaoModal.handleCancel()
    },
    handleChangeSubTaobao(data) {
      this.sub_taobao_union = data
      this.$refs.selectSubTaobaoModal.handleCancel()
    },
    handleChangeJingdong(data) {
      this.jingdong_union = data
      this.$refs.selectJingdongModal.handleCancel()
    },
    handleChangeJinbao(data) {
      this.jinbao_union = data
      this.$refs.selectJinbaoModal.handleCancel()
    }
  }
}
</script>
<style lang="less" scoped>
.select-btn {
  position: absolute;
  top: 100%;
  right: 0;
  line-height: 35px;
}
</style>